import { css } from "styled-components";

export const Center = css`
  display: flex;
  align-items: center;
  justify-content: center;
`
